import { apiRequest } from './client.js';
export async function fetchMembers() {
    return apiRequest('/leaderboard');
}
export async function addMember(name, credits) {
    return apiRequest('/leaderboard/members', {
        method: 'POST',
        body: { name, credits },
        auth: true,
    });
}
export async function removeMember(memberId) {
    return apiRequest(`/leaderboard/members/${memberId}`, {
        method: 'DELETE',
        auth: true,
    });
}
export async function updateCredits(memberId, delta, reason) {
    return apiRequest(`/leaderboard/members/${memberId}/credits`, {
        method: 'PATCH',
        body: { delta, reason },
        auth: true,
    });
}
export async function resetLeaderboard() {
    return apiRequest('/leaderboard/reset', {
        method: 'DELETE',
        auth: true,
    });
}
export async function fetchMemberHistory(memberId) {
    return apiRequest(`/leaderboard/${memberId}/history`);
}
